import { Component } from '@angular/core';

@Component({
  selector: 'app-training-plan-requirements',
  templateUrl: './training-plan-requirements.component.html',
  styleUrls: ['./training-plan-requirements.component.scss'],
})
export class TrainingPlanRequirementsComponent {
  // Component is now a simple shell - the panel-list component handles all data loading
}
